
































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import {Action} from "vuex-class";
import {MailNotifyDetailInfoItem} from "@/store/mail_notify/statistic/types";
import { colorClassByStatus } from "@/utils/page-utils";
import {notifyError, notifySuccess} from "@/utils/notify-helper";
import {dateFilter} from "@/utils/date-util";
import axios from "axios";
import {getTranslatedParams} from "@/utils/notify-utils";
import {MsgTransports} from "@/store/types";
import {ActionLog} from "@/store/auth/types";

Component.registerHooks([
  'beforeRouteLeave',
]);
@Component({
  filters: {dateFilter},
  methods: {colorClassByStatus}
})
export default class MNDetailInfo extends Vue {
  @Action("getMailNotifyStatisticDetailInfo") actionGetStatisticDetailInfo: any;
  @Action("resendMailNotifyMessage") actionResendMessage: any;
  @Action("actionLog") actionLog: any;

  defaultInfo(): MailNotifyDetailInfoItem {
    return {
      recipient: "",
      message: "",
      error_code: null,
      error_description: "",
      service_provider: null,
      status: "",
      message_category: "",
      partner: "",
      external_id: null,
      partner_user_login: "",
      id: "",
      partner_price: null,
      provider_price: null,
      broker_account_login: null,
      template_id: null,
      bulk_id: null,
      module: "",
      defer_date: null,
      sent_date: null,
      connection_type: null,
      parent_message_id: null,
      parent_message_transport: null,
    };
  }

  private messageInfo = this.defaultInfo();
  private transport = MsgTransports.MAILNOTIFY;
  private logObject: ActionLog = {};

  async created() {
    if (this.$route.params.id) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "Message",
          addititional_info: getTranslatedParams({channel: this.transport, message_id: this.$route.params.id})
        }
        await this.actionGetStatisticDetailInfo(this.$route.params.id).then((data: any) => {
          this.messageInfo = Object.assign({}, this.messageInfo, data);
        });
        await this.actionLog(this.logObject);
      } catch (err){
        await this.actionLog({...this.logObject, action_status: "failed"});
      }
    }
  }

  back(): void {
    this.$router.push('/mail_notify/detail/');
  }

  async resend(): Promise<void> {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Resending",
        action_status: "success",
        object_type: "Message",
        addititional_info: getTranslatedParams({channel: this.transport, message_id: this.$route.params.id})
      }
      await this.actionResendMessage(this.$route.params.id);
      await this.actionLog(this.logObject);
      notifySuccess(<string> this.$t('dialog.resend'));
    } catch (error) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(error)
    }
  }

  get isShowFinanceInfo(): boolean {
    let value: string = localStorage.getItem("show-finance-info") || "true";
    return JSON.parse(value)
  }
}
